import React from 'react';
import PropTypes from 'prop-types';

// Constants
import { INPUT_FOCUS_INDEX } from './searchPopupConstants';

export default (DecoratedComponent) => {
    class SearchFormInputManager extends React.Component {
        handleInputChange = (query) => {
            const { setQuery, searchQuery, disabled } = this.props;

            if (disabled) return;
            if (query === searchQuery) return;

            setQuery(query);
            this.autoSubmitSearch(query);
        };

        handleReturn = (query) => {
            const {
                searchQuery,
                focusedIndex,
                searchResultsList,
                hasMoreResults,
                loadMoreResults,
                handleResultReturnKey,
                disabled,
            } = this.props;

            if (disabled) return;

            if (focusedIndex === INPUT_FOCUS_INDEX) return;
            if (hasMoreResults && focusedIndex >= searchResultsList.length) return loadMoreResults();

            const selectedResult = searchResultsList[focusedIndex];

            if (selectedResult && handleResultReturnKey) handleResultReturnKey(selectedResult, searchQuery);
        };

        submitSearch = (query) => {
            this.cancelAutoSubmitDebounce();
            this.props.submitSearch(query);
        };

        cancelAutoSubmitDebounce = () => {
            if (!this.autoSubmitTimout) return;

            clearTimeout(this.autoSubmitTimout);
            this.autoSubmitTimout = null;
        };

        autoSubmitSearch = (query) => {
            this.cancelAutoSubmitDebounce();

            const queryLength = query.length;

            if (queryLength < 2) return;

            const searchDelay = (1 / queryLength) * 3500 + 250;

            this.autoSubmitTimout = setTimeout(() => {
                this.cancelAutoSubmitDebounce();
                this.submitSearch(query);
            }, searchDelay);
        };

        render() {
            return (
                <DecoratedComponent
                    {...this.props}
                    handleReturn={this.handleReturn}
                    cancelAutoSubmitDebounce={this.cancelAutoSubmitDebounce}
                    onChange={this.handleInputChange}
                />
            );
        }
    }

    SearchFormInputManager.propTypes = {
        searchQuery: PropTypes.string,
        searchResultsList: PropTypes.array,
        focusedIndex: PropTypes.number,
        hasMoreResults: PropTypes.bool,

        submitSearch: PropTypes.func,
        setQuery: PropTypes.func,
        loadMoreResults: PropTypes.func,
        handleResultReturnKey: PropTypes.func,
        disabled: PropTypes.bool,
    };

    return SearchFormInputManager;
};
